import React, { useState } from 'react';



const MapLabels = ({ showScenarioA, setShowScenarioA, showRidership, setShowRidership, showPopulation, setShowPopulation}) => {

  return (
    <div className='left-container'>
      {/* <div className="layer-title">
        Map Label
      </div> */}
      <div className='expansion-label'>
        <div className='label-inside'>
          <div className='large' style={{ color: 'gray' }}> □ </div>
          <div className='popup'>
            <div style={{ color: 'black' }}> 1000ft Plan Grid  &#9432;</div>
            <div className="popup-content" style={{ bottom: '-62px' }}>
              <p>To facilitate this study, a grid was created across Philadelphia with each cell measuring a 1,000ft square to reflect the maximum amount of time someone would walk to use an Indego bike.</p>
            </div>
          </div>
        </div>
        <div className='label-inside'>
          <div style={{ color: '#0078a8' }} className='large'> ● </div>
          <div style={{ color: 'black' }}> Existing Stations </div>
        </div>
        <div className='label-inside'>
          <div style={{ color: '#0078a8', opacity: 0.3 }} className='large'> ■ </div>
          <div className='popup'>
            <div style={{ color: 'black' }}> Accessible Area &#9432; </div>
            <div className="popup-content" style={{ bottom: '-27px' }}>
              <p>Total Area within 5 minutes walk from Indego stations</p>
            </div>
          </div>
        </div>
        <div className='label-inside'>
          <div style={{ color: '#0078a8', fontSize: '1.2em' }} className='large'> &#128903; </div>
          <div style={{ color: 'black' }}> New Stations </div>
        </div>
      </div>

      <div className="layer-popup">
        <button onClick={() => setShowScenarioA(!showScenarioA)} className="layer-button">
          Expansion Plan &#9432;
        </button>
        <div className="popup-content">
          Indego's current expansion priority zones.
        </div>
      </div>

      <div> 
        {showScenarioA ?
          <div className='expansion-label'>
            <div className='label-inside'>
              <div style={{ fontSize: '1.2em' }} className='green1 large'> &#128913; </div>
              <div className='green1'> High Ridership</div>
            </div>
            <div className='label-inside'>
              <div style={{ fontSize: '1.2em' }} className='green2 large'> &#128913; </div>
              <div className='green2'> Targeted/Fringe</div>
            </div>
            <div className='label-inside'>
              <div style={{ fontSize: '1.2em' }} className='green3 large'> &#128913; </div>
              <div className='green3'>Expansion Area</div>
            </div>
          </div>
        : null}
      </div>

      <div className="layer-popup">
        <button onClick={() => setShowRidership(!showRidership)} className="layer-button">
          Ridership &#9432;
        </button>
        <div className="popup-content">
          Show/Hide the ridership predcition layer
        </div>
      </div>

      <div> 
        {showRidership ?
          <div className='expansion-label'>
            <div className='label-inside'>
              <div style={{ color: '#002A11', fontSize: '1.2em' }} className='green1 large'> &#128913; </div>
              <div style={{ color: 'black' }}> High</div>
            </div>
            <div className='label-inside'>
              <div style={{ color: '#D7DEDA', fontSize: '1.2em' }} className='green2 large'> &#128913; </div>
              <div style={{ color: 'black' }}> Low</div>
            </div>
          </div>
        : null}
      </div>

      <div className="layer-popup">
        <button onClick={() => setShowPopulation(!showPopulation)} className="layer-button">
          Population &#9432;
        </button>
        <div className="popup-content">
          Show/Hide the population layer
        </div>
      </div>

      <div> 
        {showPopulation ?
          <div className='expansion-label'>
            <div className='label-inside'>
              <div style={{ color: '#002A11', fontSize: '1.2em' }} className='green1 large'> &#128913; </div>
              <div style={{ color: 'black' }}> High</div>
            </div>
            <div className='label-inside'>
              <div style={{ color: '#D7DEDA', fontSize: '1.2em' }} className='green2 large'> &#128913; </div>
              <div style={{ color: 'black' }}> Low</div>
            </div>
          </div>
        : null}
      </div>

    </div>
  );
};

export default MapLabels;